export default __webpack_public_path__ + "static/media/chachantang.5ef4685f.jpeg";